"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var DialogButton = function DialogButton(_ref) {
  var text = _ref.text,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'close' : _ref$variant,
    path = _ref.path,
    href = _ref.href,
    disabled = _ref.disabled,
    onClick = _ref.onClick;
  var buttonVariant = (0, _react.useMemo)(function () {
    return variant === 'left' ? 'text' : variant === 'close' ? 'outlined' : 'contained';
  }, [variant]);
  var buttonColor = (0, _react.useMemo)(function () {
    switch (variant) {
      case 'close':
        return 'inherit';
      case 'left':
        return 'secondary';
      default:
        return variant;
    }
  }, [variant]);
  var properties = (0, _react.useMemo)(function () {
    if (onClick) {
      return {
        onClick: onClick
      };
    }
    if (href) {
      return {
        component: 'a',
        href: href,
        target: '_blank',
        rel: 'noopener noreferrer'
      };
    }
    return {
      component: _reactRouterDom.Link,
      to: path !== null && path !== void 0 ? path : '#'
    };
  }, [onClick, path, href]);
  return /*#__PURE__*/_react["default"].createElement(_material.Button, Object.assign({
    variant: buttonVariant,
    size: "medium",
    color: buttonColor,
    disabled: disabled
  }, properties), text);
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(DialogButton);